import { AdminCategoriesPage } from '@components/pages/admin/categories/admin-categories.page';
import { AdminDomainsPage } from '@components/pages/admin/domains/admin-domains.page';
import { AdminLlmPromptsPage } from '@components/pages/admin/llm-prompts/admin-llm-prompts.page';
import { AdminLlmPage } from '@components/pages/admin/llm/admin-llm.page';
import { AdminOrganizationsPage } from '@components/pages/admin/organizations/admin-organizations.page';
import { AdminUsersPage } from '@components/pages/admin/users/admin-users.page';
import { AdminUsesPage } from '@components/pages/admin/uses/admin-uses.page';
import { CampaignDetailPage } from '@components/pages/campaigns/campaign-detail.page';
import { CampaignsListPage } from '@components/pages/campaigns/campaigns-list.page';
import { CompanyPage } from '@components/pages/company/company.page';
import { CyberAssessmentQuestionPage } from '@components/pages/cyber-assessment/cyber-assessment-question.page';
import { CyberAssessmentPage } from '@components/pages/cyber-assessment/cyber-assessment.page';
import { ExpertProfilePage } from '@components/pages/expert-profile/expert-profile.page';
import { HomePage } from '@components/pages/home/home.page';
import { InsightsPage } from '@components/pages/insights/insights.page';
import { IntelOrganizationDetailPage } from '@components/pages/intel-organizations/intel-organization-detail.page';
import { IntelOrganizationsPage } from '@components/pages/intel-organizations/intel-organizations.page';
import { IntelTechnologiesPage } from '@components/pages/intel-technologies/intel-technologies.page';
import { MeiaStudiesPage } from '@components/pages/meia/meia-studies.page';
import { MeiaStudyCreatePage } from '@components/pages/meia/meia-study-create.page';
import { MeiaStudyShellPage } from '@components/pages/meia/meia-study-shell.page';
import { MissionAssessmentCreatePage } from '@components/pages/mission-assessment/mission-assessment-create.page';
import { MissionAssessmentEditPage } from '@components/pages/mission-assessment/mission-assessment-edit.page';
import { MissionAssessmentsPage } from '@components/pages/mission-assessment/mission-assessments.page';
import { ProductPage } from '@components/pages/product/product.page';
import { ProductsPage } from '@components/pages/product/products.page';
import { QuestionPage } from '@components/pages/question/question.page';
import { SurveyPage } from '@components/pages/survey/survey.page';
import { TechChallengeDetailPage } from '@components/pages/tech-challenges/tech-challenge-detail.page';
import { TechChallengesListPage } from '@components/pages/tech-challenges/tech-challenges-list.page';
import { TechnologiesPage } from '@components/pages/technology/technologies.page';
import { TechnologyPage } from '@components/pages/technology/technology.page';
import { ThreadsPage } from '@components/pages/threads/threads.page';
import { ParentPortfolioPage } from './components/pages/parent-organizations/parent-portfolio.page';
import { ParentProjectsPage } from './components/pages/parent-organizations/parent-projects.page';
import { ResearchPage } from './components/pages/research/research.page';

export type RouteKey =
  | 'adminCategories'
  | 'adminDomains'
  | 'adminLlm'
  | 'adminLlmPrompts'
  | 'adminOrganizations'
  | 'adminUses'
  | 'adminUsers'
  | 'campaignDetail'
  | 'campaigns'
  | 'cyberAssessment'
  | 'cyberAssessmentQuestion'
  | 'expertProfile'
  | 'home'
  | 'insights'
  | 'intelOrganizationDetail'
  | 'intelOrganizations'
  | 'intelTechnologies'
  | 'meia'
  | 'meiaStudies'
  | 'meiaStudy'
  | 'meiaStudyCreate'
  | 'meiaStudyTab'
  | 'missionAssessments'
  | 'missionAssessmentCreate'
  | 'missionAssessmentEdit'
  | 'organization'
  | 'portfolio'
  | 'product'
  | 'projects'
  | 'products'
  | 'question'
  | 'research'
  | 'survey'
  | 'techChallenges'
  | 'techChallengeDetail'
  | 'technologies'
  | 'technology'
  | 'threads';

export type Route = {
  element: () => JSX.Element;
  icon?: JSX.Element;
  onClick?: () => void;
  path: string;
};

export const routes: Record<RouteKey, Route> = {
  adminCategories: {
    element: () => <AdminCategoriesPage />,
    path: '/admin/categories',
  },
  adminDomains: {
    element: () => <AdminDomainsPage />,
    path: '/admin/domains',
  },
  adminLlm: {
    element: () => <AdminLlmPage />,
    path: '/admin/llm',
  },
  adminLlmPrompts: {
    element: () => <AdminLlmPromptsPage />,
    path: '/admin/llm/prompts',
  },
  adminOrganizations: {
    element: () => <AdminOrganizationsPage />,
    path: '/admin/organizations',
  },
  adminUses: {
    element: () => <AdminUsesPage />,
    path: '/admin/uses',
  },
  adminUsers: {
    element: () => <AdminUsersPage />,
    path: '/admin/users',
  },
  campaignDetail: {
    element: () => <CampaignDetailPage />,
    path: '/campaigns/:campaignId',
  },
  campaigns: {
    element: () => <CampaignsListPage />,
    path: '/campaigns',
  },
  cyberAssessment: {
    element: () => <CyberAssessmentPage />,
    path: '/technology/:technologyId/cyber-assessment/:cyberAssessmentId',
  },
  cyberAssessmentQuestion: {
    element: () => <CyberAssessmentQuestionPage />,
    path: '/technology/:technologyId/cyber-assessment/:cyberAssessmentId/section/:sectionId',
  },
  expertProfile: {
    element: () => <ExpertProfilePage />,
    path: '/expert-profile',
  },
  home: {
    element: () => <HomePage />,
    path: '/',
  },
  insights: {
    element: () => <InsightsPage />,
    path: '/insights',
  },
  intelOrganizationDetail: {
    element: () => <IntelOrganizationDetailPage />,
    path: '/intel/organizations/:companyId',
  },
  intelOrganizations: {
    element: () => <IntelOrganizationsPage />,
    path: '/intel/organizations',
  },
  intelTechnologies: {
    element: () => <IntelTechnologiesPage />,
    path: '/intel/technologies',
  },
  meia: {
    element: () => <MeiaStudiesPage />,
    path: '/meia',
  },
  meiaStudies: {
    element: () => <MeiaStudiesPage />,
    path: '/meia/studies',
  },
  meiaStudy: {
    element: () => <MeiaStudyShellPage />,
    path: '/meia/:studyId',
  },
  meiaStudyCreate: {
    element: () => <MeiaStudyCreatePage />,
    path: '/meia/studies/new',
  },
  meiaStudyTab: {
    element: () => <MeiaStudyShellPage />,
    path: '/meia/:studyId/:tab',
  },
  missionAssessments: {
    element: () => <MissionAssessmentsPage />,
    path: '/assessments',
  },
  missionAssessmentCreate: {
    element: () => <MissionAssessmentCreatePage />,
    path: '/technology/:technologyId/assessment/create',
  },
  missionAssessmentEdit: {
    element: () => <MissionAssessmentEditPage />,
    path: '/technology/:technologyId/assessment/:missionAssessmentDraftId/edit',
  },
  organization: {
    element: () => <CompanyPage />,
    path: '/organization',
  },
  portfolio: {
    element: () => <ParentPortfolioPage />,
    path: '/portfolio',
  },
  product: {
    element: () => <ProductPage />,
    path: '/product/:productId',
  },
  projects: {
    element: () => <ParentProjectsPage />,
    path: '/projects',
  },
  products: {
    element: () => <ProductsPage />,
    path: '/products',
  },
  question: {
    element: () => <QuestionPage />,
    path: '/technology/:technologyId/survey/:surveyId/section/:sectionId',
  },
  research: {
    element: () => <ResearchPage />,
    path: '/research',
  },
  survey: {
    element: () => <SurveyPage />,
    path: '/technology/:technologyId/survey/:surveyId',
  },
  techChallenges: {
    element: () => <TechChallengesListPage />,
    path: '/tech-challenges',
  },
  techChallengeDetail: {
    element: () => <TechChallengeDetailPage />,
    path: '/tech-challenges/:id',
  },
  technology: {
    element: () => <TechnologyPage />,
    path: '/technology/:technologyId',
  },
  technologies: {
    element: () => <TechnologiesPage />,
    path: '/technologies',
  },
  threads: {
    element: () => <ThreadsPage />,
    path: '/threads',
  },
};
